import React, { Component } from 'react';
import PropTypes from 'prop-types';
// IE11 needs a few polyfills.
import 'core-js/fn/array/from';
import 'core-js/es6/set';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import throttle from 'lodash/throttle';
import classnames from 'classnames';

import 'react-dates/lib/css/_datepicker.css';

import Button from '../button/button';
import Dropdown from '../dropdown/dropdown';

import styles from '../filter/filter.module.scss';

class DateFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orientation: 'vertical'
    };

    this.handleResize = throttle(this.handleResize.bind(this), 500);
  }

  componentDidMount() {
    if (window.innerWidth > 1100) {
      this.setState({ orientation: 'horizontal' });
    }

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (window.innerWidth > 1100) {
      this.setState({ orientation: 'horizontal' });
    }
    else {
      this.setState({ orientation: 'vertical' });
    }
  }

  render() {
    const buttonClass = classnames(styles.button, {
      [styles.active]: this.props.startDate
    });

    return (
      <li>
        <Dropdown
          className={buttonClass}
          color={false}
          buttonContent="Dates"
          id="date-range-picker"
        >
          <form className={styles.filterDropdown}>
            <DateRangePicker
              startDate={this.props.startDate} // momentPropTypes.momentObj or null,
              startDateId="date-range-picker-start" // PropTypes.string.isRequired,
              endDate={this.props.endDate} // momentPropTypes.momentObj or null,
              endDateId="date-range-picker-end" // PropTypes.string.isRequired,
              onDatesChange={({ startDate, endDate }) =>
                this.props.handleDateUpdate({ startDate, endDate })
              } // PropTypes.func.isRequired,
              focusedInput={this.props.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
              onFocusChange={(focusedInput) =>
                this.props.handleDateUpdate({ focusedInput })
              } // PropTypes.func.isRequired,
              small={true}
              hideKeyboardShortcutsPanel={true}
              transitionDuration={0}
              orientation={this.state.orientation}
            />
            <Button
              style={{ marginLeft: '1rem', padding: '0.6em 1.5em' }}
              size="small"
              type="submit"
              onClick={this.props.handleDateSubmit}
            >
              Update
            </Button>
          </form>
        </Dropdown>
      </li>
    );
  }
}

DateFilter.propTypes = {
  handleDateUpdate: PropTypes.func,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  focusedInput: PropTypes.string,
  handleDateSubmit: PropTypes.func
};

export default DateFilter;
